import './styles.scss';

import React, {PropsWithChildren} from 'react';

export enum AppMarkTheme {
    ORANGE = 'orange',
    GREEN = 'green',
}

export enum AppMarkSize {
    SMALL = 'small',
    MIDDLE = 'middle',
}

interface AppMarkProps extends PropsWithChildren {
    theme?: AppMarkTheme;
    size?: AppMarkSize;
}

export const AppMark = ({children, theme = AppMarkTheme.ORANGE, size = AppMarkSize.MIDDLE}: AppMarkProps) => {
    return <div className={`app-mark ${theme} ${size}`}>{children}</div>;
};
